import PropTypes from "prop-types";
import Card from "@mui/material/Card";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import colors from "assets/theme/base/colors";

function ConversionFunnel({ steps }) {
  const max = steps[0]?.value || 100;

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: "1.25rem",
        border: "none",
        boxShadow: "0 4px 24px rgba(52, 71, 103, 0.07)",
        overflow: "hidden",
      }}
    >
      <SoftBox p={{ xs: 3, md: 3.5 }}>
        <SoftTypography variant="h6" fontWeight="bold" mb={1} sx={{ lineHeight: 1.35 }}>
          User conversion
        </SoftTypography>
        <SoftTypography variant="caption" color="text" display="block" mb={3.5} sx={{ lineHeight: 1.55 }}>
          Signup through mission flown (sample cohort)
        </SoftTypography>
        <SoftBox display="flex" flexDirection="column" alignItems="center" gap={1.5}>
          {steps.map((step, index) => {
            const pct = max > 0 ? (step.value / max) * 100 : 0;
            const widthPct = 38 + (pct / 100) * 58;
            return (
              <SoftBox key={step.label} width="100%" display="flex" flexDirection="column" alignItems="center">
                <SoftBox
                  sx={{
                    width: `${widthPct}%`,
                    minHeight: "2.5rem",
                    borderRadius: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    background: `linear-gradient(90deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                    opacity: 0.95 - index * 0.06,
                    boxShadow: "0 2px 8px rgba(0, 32, 84, 0.12)",
                  }}
                >
                  <SoftTypography variant="button" fontWeight="bold" color="white" sx={{ fontSize: "0.75rem" }}>
                    {step.label}
                  </SoftTypography>
                  <SoftTypography variant="button" fontWeight="bold" color="white" sx={{ fontSize: "0.75rem" }}>
                    {step.value}%
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            );
          })}
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

ConversionFunnel.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default ConversionFunnel;
